import type { HsShaderType } from '../enums/shader-type.enum';

export function hsCompileShader(
  gl: WebGL2RenderingContext,
  shaderSource: string,
  shaderType: HsShaderType,
  deferValidation: boolean = false
): WebGLShader {
  const shader: WebGLShader | null = gl.createShader(gl[shaderType]);

  if (shader === null) {
    throw new Error(`ERROR: compileShader - Failed to create WebGLShader`);
  }

  gl.shaderSource(shader, shaderSource);
  gl.compileShader(shader);

  if (!deferValidation && !Boolean(gl.getShaderParameter(shader, gl.COMPILE_STATUS))) {
    const message: string = `ERROR: compileShader - Shader compilation error: ${gl.getShaderInfoLog(
      shader
    )}${shaderSource}`;
    gl.deleteShader(shader);
    throw new Error(message);
  }

  return shader;
}
